module.exports = __webpack_public_path__ + "static/media/malavika.77ad624c.jpg";